import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ISensorIdMapping,
  ISensorIdMappingRow,
} from '../../../../view/settings/api-automation-settings/sensor-id-mapping/sensor-id-mapping.model';

@Injectable({
  providedIn: 'root',
})
export class SensorIdMappingService {
  private readonly SENSOR_ID_MAPPING_URL = `${this.baseUrl}/api-automation/sensor-id-mapping`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ISensorIdMapping>> {
    return this.http.get<GetManyResponseInterface<ISensorIdMapping>>(this.SENSOR_ID_MAPPING_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ISensorIdMapping>> {
    return this.http.get<BaseOneResponseInterface<ISensorIdMapping>>(`${this.SENSOR_ID_MAPPING_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: ISensorIdMappingRow): Observable<BaseOneResponseInterface<ISensorIdMapping>> {
    return this.http.post<BaseOneResponseInterface<ISensorIdMapping>>(this.SENSOR_ID_MAPPING_URL, record);
  }

  public editOne(
    recordId: number,
    record: ISensorIdMappingRow,
  ): Observable<BaseOneResponseInterface<ISensorIdMapping>> {
    return this.http.patch<BaseOneResponseInterface<ISensorIdMapping>>(
      `${this.SENSOR_ID_MAPPING_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          sensorIdMappings: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.SENSOR_ID_MAPPING_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.SENSOR_ID_MAPPING_URL}/${recordIds[0]}`);
  }
}
